import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const ContainerErro = styled.textarea`
  width: 100%;
  height: 438px;
  flex-direction: column;
  align-items: flex-start;
  border: 2px solid #b6bfc8;
  box-sizing: border-box;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae60};
  resize: none;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 438px;
`;

export const ErrorWrapper = styled.div`
  section {
    position: relative;
  }
`;
